export default __webpack_public_path__ + "static/media/20200312_130027_Original.cc90cc27.jpg";